// src/pages/RoomsAndBunks.jsx

import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from './Header';
import Footer from './Footer';
import HeaderNavbar from './MainHeader';
import SidebarOryza from './SidebarOryza';
import Sidebar from './SideNavigation';
import '../styles/RoomsAndBunks.css';
import { ReactComponent as BedIcon } from './double-bed.svg';
import { ReactComponent as People } from './people-_1_.svg';
import { Link } from 'react-router-dom';

const rooms = [
    {
        title: "Deluxe King Room",
        image: "/bbkandy/images/rooms/room/double.webp",
        bed: "1 King Bed",
        guests: "2 Guests",
        link: "/BananaBunksKandy/room/kingroom",
    },
    {
        title: "Deluxe Twin Room",
        image: "/bbkandy/images/rooms/room/twin.webp",
        bed: "2 Single Beds",
        guests: "2 Guests",
        link: "/BananaBunksKandy/room/twinroom",
    },
    {
        title: "Bed in 8-Bed Dormitory Room",
        image: "/bbkandy/images/rooms/room/bunk8.webp",
        bed: "8 Bunk Beds",
        guests: "8 Guests",
        link: "/BananaBunksKandy/room/bedin8bed",
    },
    {
        title: "Bed in 6-Bed Dormitory Room",
        image: "/bbkandy/images/rooms/room/bunk6.webp",
        bed: "6 Bunk Beds",
        guests: "6 Guests",
        link: "/BananaBunksKandy/room/bedin6bed",
    },
];

const RoomsAndBunks = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkScreen = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkScreen(); // Run on mount
        window.addEventListener('resize', checkScreen);
        return () => window.removeEventListener('resize', checkScreen);
    }, []);

    const headingStyle = {
        fontFamily: "'Yellowtail', cursive",
        fontWeight: 400,
        fontSize: isMobile ? '40px' : '79px',
        lineHeight: isMobile ? '48px' : '95px',
        color: '#fff',
    };

    return (
        <>
            <Helmet>
                <title>Rooms & Bunks | Banana Bunks Kandy | Oryza Leisure</title>
                <link
                    href="https://fonts.googleapis.com/css2?family=Jost:wght@300;500;700&family=Yellowtail&display=swap"
                    rel="stylesheet"
                />
                <script src="https://kit.fontawesome.com/a076d05399.js" crossOrigin="anonymous"></script>
            </Helmet>

            <Header />
            <HeaderNavbar />
            <SidebarOryza />
            <Sidebar />

            <div className="rooms-header" style={{
                backgroundImage: "url(/bbkandy/images/rooms/header.webp)",
                height: '480px',
            }}>
                <div className="overlay" />
                <div className="container">
                    <h1
                        className="hotale-additional-font hotale-page-title media-title"
                        style={headingStyle}
                    >
                        Our Rooms and Bunks
                    </h1>
                </div>
            </div>

            <div className="rooms-page">
                <div className="rooms-container">
                    {rooms.map((room, index) => (
  <div className="room-card" key={index}>
    <img src={room.image} alt={room.title} className="room-image" />
    <div className="room-content">
      <h3 className="room-title">
        <Link to={room.link} className="room-title-link">
          {room.title}
        </Link>
      </h3>
      <div className="room-info">
        <div><BedIcon className="icon-bed" /> {room.bed}</div>
        <div><People className="icon-bed" /> {room.guests}</div>
      </div>
      <Link to={room.link} className="book-link">
        Book Now <i className="icon-arrow-right greencolor"></i>
      </Link>
    </div>
  </div>
))}
                </div>
            </div>

            <Footer />

            <div className="progress-wrap">
                <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
                    <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
                </svg>
            </div>
        </>
    );
};

export default RoomsAndBunks;
